import "./styles.scss";
import React, { FC, useState, useEffect } from "react";
import CompanyDetailDraggable from "../CompanyDetailDraggable/CompanyDetailDraggable";
import CompanyHighLightCard from "./CompanyHighLightCard";
import CompanySocialCard from "./CompanySocialCard";
import CompanyPortfoliosCard from "./CompanyPortfoliosCard";
import TeamSection from "./Sections/TeamSection";
import AboutSection from "./Sections/AboutSection";
import MediaSection from "./Sections/MediaSection";
import UpdatesSection from "./Sections/UpdatesSection";
import SocialsFeedSection from "./Sections/SocialsFeedSection";
import SubscribeLinkGeneratorCard from "SubscribeLinkGeneratorCard";
import { useUserHasAdminAccessToCompany } from "psHooks";
import { useCompanyMedia, useCompanyTeam } from "queryHooks";
import { Shimmer } from "Shimmers";

interface IProps {
  company: { company_id: string; media: []; long_description: {} } | any;
  companyIsLoaded: boolean;
  companyNotFound?: boolean;
}

const CompanyDetailContent: FC<IProps> = ({
  company,
  companyIsLoaded,
  companyNotFound,
}: IProps) => {
  const userHasAdminAccessToCompany = useUserHasAdminAccessToCompany({
    company_id: company.company_id,
  });

  const { data: companyMedia = [] } = useCompanyMedia({
    companyId: company.company_id,
  });

  const [visibleCompanyMediaItems, setVisibleCompanyMediaItems] = useState([]);
  const [showAboutSection, setShowAboutSection] = useState(false);

  useEffect(() => {
    let visibleCompanyMediaItems = companyMedia
      ? companyMedia.filter(
          (mediaItem) => mediaItem.type !== "company_banner_video"
        )
      : [];

    setVisibleCompanyMediaItems(visibleCompanyMediaItems);
  }, [companyMedia]);

  useEffect(() => {
    if (
      company.long_description &&
      company.long_description.ops &&
      company.long_description.ops[0] &&
      company.long_description.ops[0].insert !== "\n"
    ) {
      setShowAboutSection(true);
    }
  }, [company.long_description]);

  const { data: companyTeam = [] } = useCompanyTeam({
    companyId: company.company_id,
  });

  return (
    <>
      {companyIsLoaded === true && (
        <div className="ps-company-detail-content container">
          <div className="ps-company-detail-content--first-column">
            {/*Updates Section*/}
            <CompanyDetailDraggable
              // loadMoreText={"View all updates"}
              loadMoreHasBorder={true}
              loadMoreHighlighted={true}
            >
              {/* <TeamSection company={company} /> */}
              <UpdatesSection company={company} />
            </CompanyDetailDraggable>

            {/*Team Section*/}
            {companyTeam.length > 0 && (
              <CompanyDetailDraggable
                // loadMoreText={"+ 8 others"}
                loadMoreHasBorder={false}
                loadMoreHighlighted={false}
              >
                <TeamSection company={company} />
              </CompanyDetailDraggable>
            )}

            {/*Socials Section*/}
            {company.twitter_url && company.twitter_url.length > 0 && (
              <CompanyDetailDraggable
                // loadMoreText={"+ 8 others"}
                loadMoreHasBorder={false}
                loadMoreHighlighted={false}
              >
                <SocialsFeedSection
                  company={company}
                  showSocialsFeedSection={() => null}
                />
              </CompanyDetailDraggable>
            )}

            {/*About Section*/}
            {showAboutSection && (
              <CompanyDetailDraggable
                loadMoreHasBorder={false}
                loadMoreHighlighted={false}
              >
                {/* <AboutCompanyProvider> */}
                <AboutSection company={company} />
                {/* </AboutCompanyProvider> */}
              </CompanyDetailDraggable>
            )}

            {/*Media Section*/}

            {visibleCompanyMediaItems.length > 0 && (
              <CompanyDetailDraggable
                loadMoreHasBorder={false}
                loadMoreHighlighted={false}
              >
                <MediaSection company={company} />
              </CompanyDetailDraggable>
            )}
          </div>

          <div className="ps-company-detail-content--second-column">
            <CompanyHighLightCard company={company} />
            {userHasAdminAccessToCompany === true && (
              <SubscribeLinkGeneratorCard />
            )}
            <CompanySocialCard company={company} />
            <CompanyPortfoliosCard company={company} />
          </div>
        </div>
      )}

      {companyIsLoaded === false && companyNotFound === false && (
        <div className="ps-company-detail-content container">
          <div className="ps-company-detail-content--first-column">
            <div
              className="ps-company-detail-draggable"
              style={{ marginBottom: "30px" }}
            >
              <div className="ps-company-detail-draggable__inner-container">
                <Shimmer
                  shimmerStyles={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "5px",
                  }}
                />
              </div>
            </div>
            <div
              className="ps-company-detail-draggable"
              style={{ marginBottom: "30px" }}
            >
              <div className="ps-company-detail-draggable__inner-container">
                <Shimmer
                  shimmerStyles={{
                    width: "100%",
                    height: "400px",
                    borderRadius: "5px",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="ps-company-detail-content--second-column">
            <div className="ps-company-detail-content__profile-highlight-card ps-company-detail-content__highlight-card-width-container">
              <Shimmer
                shimmerStyles={{
                  width: "100%",
                  height: "400px",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CompanyDetailContent;
